import React, { useMemo, useCallback, useState,useEffect } from 'react';


import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { SampleType } from '@/features/alojamientos/services/sampleTypeService';
import eventBus from '@/utils/eventBus';


interface SampleCountCardsProps {
  sampleTypes: SampleType[];
  onSelectBySampleType: (sampleTypeId: string) => void;
  selectedSampleId: string;
}

const SampleCountCards: React.FC<SampleCountCardsProps> = ({ 
  sampleTypes,
  onSelectBySampleType,
  selectedSampleId
}) => {
  const [localSelectedId, setLocalSelectedId] = useState<string>(selectedSampleId);

  const handleCardClick = useCallback((typeId: string) => {
    setLocalSelectedId(typeId);
    onSelectBySampleType(typeId);
  }, [onSelectBySampleType]);

  useEffect(() => {
    const handler = (newSampleId: string) => {
      console.log('📡 sampleId actualizado:', newSampleId);
      setLocalSelectedId(newSampleId);
    };
    eventBus.on('sampleIdChange', handler);
    return () => {
      eventBus.off('sampleIdChange', handler); // Limpieza al desmontar
    };
  }, []);

  const renderResult = useMemo(() => (
    <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-6">
      {sampleTypes.map((type) => {
        const typeId = type.id.toString();
        const isSelected = localSelectedId === typeId;
        return (
          <Card 
            key={type.id} 
            className={`cursor-pointer transition-colors ${
              isSelected
                ? 'bg-green-50 border-green-200 hover:bg-green-100' 
                : 'hover:bg-gray-50'
            }`}
            onClick={handleCardClick.bind(null, typeId)}
          >
            <CardHeader className="pb-2">
              <CardTitle className="text-lg font-medium capitalize">
                {type.name}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="flex items-center justify-between">
                <span className="text-2xl font-bold text-blue-600">{type.accommodationCount}</span>
                <Badge variant="outline" className="bg-blue-50 text-blue-700 border-blue-200">
                  Establecimientos
                </Badge>
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  ), [sampleTypes, localSelectedId, handleCardClick]);

  return renderResult;
};

export default React.memo(SampleCountCards);
